import {InjectionToken} from '@angular/core';

/**
 * Политика маршрутизации приложения для гардов этой библиотеки (SEO, ЧПУ).
 *
 * Гарды `compob2b-auth` общие для витрины и админки. Бэкенд проверяет доступ как
 * `strpos(:url, menu.uri) > 0`, то есть значения `menu.uri` в БД остаются контрактом
 * для фронтовых путей. У админки они совпадают с её URL, у витрины после переезда
 * главной в `/` уже нет: на `/` бэкенд отвечает отказом.
 *
 * Зашить карту витрины сюда нельзя: правило `/` → `/cabinet/dashboard` переписало бы
 * и запросы админки. Поэтому преобразование задаёт приложение, а дефолт сохраняет
 * прежнее поведение.
 */

/**
 * Преобразование URL навигации в форму, которую понимает `menu.uri`. Дефолт —
 * тождество: админка не затронута. Витрина провайдит своё (`legacy-url-map.ts`).
 */
export const DEFAULT_MENU_ACCESS_URL_NORMALIZER = (url: string): string => url;

export const MENU_ACCESS_URL_NORMALIZER = new InjectionToken<(url: string) => string>(
  'MENU_ACCESS_URL_NORMALIZER',
  {providedIn: 'root', factory: () => DEFAULT_MENU_ACCESS_URL_NORMALIZER},
);
